import {connect} from 'react-redux';
import {MultiSelect as Component} from './MultiSelect';
import {submitQuestionAnswer} from '@learningblocks/exp-redux/lib/Actions';
import {selectCheckboxOption} from '@learningblocks/exp-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    selectOption: (params) => {
      dispatch(selectCheckboxOption(params));
    },
    submitAnswer: (id, type) => {
      dispatch(submitQuestionAnswer(id, type));
    },
  };
}

const MultiSelect = connect(mapStateToProps, mapDispatchToProps)(Component);

export {MultiSelect as MultiSelectWithRedux, Component as MultiSelect};
